module.exports = __webpack_public_path__ + "img/undraw_hello.c84c6021.svg";